export default __webpack_public_path__ + "static/media/mash-bnb.24610a8c.png";